import { createSlice } from "@reduxjs/toolkit";
import { LOCAL_STORAGE_KEYS } from "../../../Util/constants";

const initialState = {
  postcastAuthToken: null,
  username: null,
};

export const stateSlice = createSlice({
  name: LOCAL_STORAGE_KEYS.PUBLIC_STATE,
  initialState,
  reducers: {
    setPublicUser: (state, action) => {
      state.username = action.payload.username;
    },
    setPostcastAuthToken: (state, action) => {
      state.postcastAuthToken = action.payload;
    }
  },
});

// Additional logic for saving and loading from localStorage
export const loadModalFromLocalStorage = () => {
  const storedState = localStorage.getItem(LOCAL_STORAGE_KEYS.STATE);
  if (!storedState) return stateSlice.initialState;
  const newStateSlice = JSON.parse(storedState);
  newStateSlice.modalStack = [];
  return newStateSlice;
};

export const saveStateToLocalStorage = (modal) => {
  // const persistedState = { ...modal, activeModal: null };
  // localStorage.setItem(
  //   LOCAL_STORAGE_KEYS.PUBLIC_STATE
  // );
};

// Action creators are generated for each case reducer function
export const { setPublicUser, setPostcastAuthToken } = stateSlice.actions;

export default stateSlice.reducer;
